
export function checkWord(solution, attempt) {
    const status = Array(solution.length).fill("absent");
    const solArray = solution.split("");

    // Première passe : exact
    attempt.split("").forEach((l, i) => {
      if (l === solArray[i]) {
        status[i] = "correct";
        solArray[i] = null;
      }
    });

    // Deuxième passe : présent
    attempt.split("").forEach((l, i) => {
      if (status[i] === "correct") return;
      if (status[i] === "present") return;
      const pos = solArray.indexOf(l);
      if (pos !== -1) {
        status[i] = "present";
        solArray[pos] = null;
      }
    });

    return status;
}

// clear data when game is over
export function clearStorage(userId) {
  localStorage.removeItem('motus_grid_'+userId);
  localStorage.removeItem('motus_statuses_'+userId);
  localStorage.removeItem('motus_confirmed_'+userId);
  localStorage.removeItem('motus_word_'+userId);
  localStorage.removeItem('motus_validate_'+userId);
  localStorage.removeItem('motus_keyboard_'+userId);
}

export function forceLogout() {
  if (localStorage.getItem('motus_user_id') !== null) {
      localStorage.removeItem('motus_user_id');
      window.location.replace("/");
  }
}

// Stocker avec une date d'expiration
export function setWithExpiry(key, value, ttl) {
	const now = new Date();
	const item = {
		value: value,
		expiry: now.getTime() + ttl, // TTL en millisecondes
	};
	localStorage.setItem(key, JSON.stringify(item));
}

// Lire avec vérification
export function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key);
	if (!itemStr) return null;
	const item = JSON.parse(itemStr);
	const now = new Date();
	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key);
		return null;
	}
	return item.value;
}